import { actionCreator } from '../../../utils/actions';

export const toggleGeozoneEditor = actionCreator('Geozones/TOGGLE_GEOZONE_EDITOR');
export const createGeozoneClicked = actionCreator('Geozones/CREATE_GEOZONE_CLICKED');
export const deleteGeozoneClicked = actionCreator('Geozones/DELETE_GEOZONE_CLICKED');
export const editGeozoneClicked = actionCreator('Geozones/EDIT_GEOZONE_CLICKED');
export const activateGeozoneClicked = actionCreator('Geozones/ACTIVATE_GEOZONE_CLICKED');
export const updateGeozoneClicked = actionCreator('Geozones/UPDATE_GEOZONE_CLICKED');



// WEBPACK FOOTER //
// ./src/components/Modal/GeozonesModal/actions.js